<template>
  <div class="user-details-card">
    <div id="active-user" v-if="userDetails.status === 'active'">
      <div class="status-dot active">
      </div>
      <div class="user-info">
        <img v-if="userDetails.gender == 'M'" class="avatar rounded-circle" src="/img/persons/male-avatar.png"
          :alt="userDetails.name" />
        <img v-if="userDetails.gender == 'F'" class="avatar rounded-circle" src="/img/persons/female-avatar.png"
          :alt="userDetails.name" />

        <div>
          <h3  :title="userDetails.name" class="name username active-name">{{ userDetails.name }}</h3>
          <div class="duration">
            <i class="fas fa-clock"></i>
            {{ formattedTime }}
          </div>
        </div>
      </div>

      <div class="hr-zone" :class="userDetails.hrzChallengeClass">HR ZONE: {{ userDetails.hrzChallengeLabel }}</div>
      <div class="heart-section">
        <div class="heart-rate" style="width: 40%;">
          <div>
            <div :class="{ 'extreme-hr': userDetails.hrzChallengeLabel == 'EXTREME' }">{{ userDetails.hr }}</div>
            <div style="font-size: 1rem;color: #bbb;">BPM</div>
          </div>
          <i style="padding-top: 0.8rem;" class="fas fa-heart"></i>
        </div>
        <HRZoneBar :heartRate="userDetails.hr" :hrZone="userDetails.hrzChallengeClass"/>
        <div class="hr-stats d-flex justify-content-between" style="width: 40%;">
          <div>
            <span style="font-size: 1.2rem;">AVG</span>
            <span style="font-size: 1.4rem;">{{ userDetails.avgHr }}</span>
          </div>
          <div>
            <span style="font-size: 1.2rem;">MAX</span>
            <span style="font-size: 1.4rem;">{{ userDetails.maxHr }}</span>
          </div>
        </div>
      </div>

      <div class="metrics">
        <div class="metric">
          <IconSpo color="#bce1da" />
          <div class="metric-value" style="">{{ userDetails.spo2 }}</div>
          <div class="metric-label text-capitalize">SPO2</div>
        </div>

        <div class="metric">
          <IconSteps color="#bce1da" />
          <div class="metric-value">{{ userDetails.steps }}</div>
          <div class="metric-label text-capitalize">STEPS</div>
        </div>

        <div class="metric">
          <IconCalories color="#bce1da" />
          <div class="metric-value">{{ Math.round(userDetails.calories / 1000)}} kcal</div>
          <div class="metric-label text-capitalize">CALORIES</div>
        </div>
      </div>
    </div>

    <div v-else class="user-offiline-card">
      <div class="offline-status-dot"></div>

      <div> 
        <img v-if="userDetails.gender == 'M'" class="avatar rounded-circle" src="/img/persons/male-avatar.png"
          :alt="userDetails.name" />
        <img v-if="userDetails.gender == 'F'" class="avatar rounded-circle" src="/img/persons/female-avatar.png"
          :alt="userDetails.name" />
      </div>
      <h3 :title="userDetails.name" class="name username in-active-name">{{ userDetails.name }}</h3>
      <div class="device-status">
        <IconFitBand color="#bce1da" :size="'2rem'" />
        <span class="offline-text">Offline</span>
      </div>
    </div>
  </div>
</template>

<script>
import HRZoneBar from './HRZoneBar.vue';
import IconSteps from "@/shared/Controls/Icons/IconSteps.vue";
import IconCalories from "@/shared/Controls/Icons/IconCalories.vue";
import IconSpo from "@/shared/Controls/Icons/IconSpo.vue";
import IconFitBand from "@/shared/Controls/Icons/IconFitBand.vue";

export default {
  name: 'UserChallengeCard',
  components: {
    HRZoneBar,
    IconSteps,
    IconCalories,
    IconSpo,
    IconFitBand,
  },
  props: {
    userDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      durationInSeconds: 0,
      timer: null,
      isRunning: false,
    }
  },
  mounted() {
    if (this.userDetails.status === 'active') {
      this.startTimer();
    } 
  },
  watch: {
    userDetails(newVal) {
      if (newVal.status === 'active') {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    },
  },
  computed: {
    formattedTime() {
      const hrs = Math.floor(this.durationInSeconds / 3600);
      const mins = Math.floor((this.durationInSeconds % 3600) / 60);
      const secs = this.durationInSeconds % 60;
      return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    },
  },
  methods: {
    startTimer() {
      if (!this.isRunning) {
        this.timer = setInterval(() => {
          this.durationInSeconds++;
          let userDuration = {
            udid: this.userDetails.udid,
            duration: this.durationInSeconds,
          };
        this.$emit('update-user-duration', userDuration);
        }, 1000);
        this.isRunning = true;
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.isRunning = false;
    },
    resetTimer() {
      this.stopTimer();
      this.durationInSeconds = 0;
    },
  },
  beforeUnmount() {
    this.stopTimer();
  },
};
</script>

<style scoped>
.user-details-card {
  width: 16.5rem;
  background: linear-gradient(to bottom right, #1c1c1c, #2e2e2e);
  border-radius: 0.5rem;
  padding: 16px;
  color: #fff;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.6);
  position: relative;
  padding: 0.5rem;
  background: #161717;
  height: 100%;
}

.status-dot {
  position: absolute;
  /* top: 0.8rem; */
  right: 0.7rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}

.active {
  background: #4aff65;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-info img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
}

.user-info h3 {
  margin: 0;
  font-size: 1.25rem;
}

.name {
  font-size: 1.25rem;
  font-weight: 400;
}

.active-name {
  max-width: 15ch; 
}

.in-active-name {
  max-width: 20ch; 
}

.username {
  display: inline-block;
           /* Limit to 10 characters */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  cursor: default;
}

.duration {
  display: flex;
  align-items: center;
  font-size: 1rem;
  margin-top: 0.1rem;
  color: #ccc;
}

.duration i {
  margin-right: 0.5rem;
}

.hr-zone {
  text-align: center;
  padding: 0.3rem;
  border-radius: 0.25rem;
  margin-top: 0.5rem;
  font-weight: bold;
  font-size: 0.9rem;
}

.extreme-zone {
  background-color: #d60000;
  color: #fff;
}

.extreme-color {
  color: #fff;
}

.extreme-hr {
  color: #d60000;
}

.normal-color {
  color: #000;
}

.resting-zone {
  background-color: rgb(166, 26, 247);
  color: #000;
}

.warmup-zone {
  background-color: #74b8e6;
  color: #000;
}

.fat-burning-zone {
  background-color: #96f189;
  color: #000;
}

.aerobic-zone {
  background-color: #ffe14b;
  color: #000;
}

.anaerobic-zone {
  background-color: #e57e12;
  color: #000;
}

.heart-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
  padding-top: 0.75rem;
}

.heart-rate {
  font-size: 2rem;
  display: flex;
  /* align-items: center; */
  gap: 0.5rem;
}

.hr-bar {
  display: flex;
  flex-direction: column-reverse;
  gap: 0.25rem;
}

.bar {
  width: 1.5rem;
  height: 0.4rem;
  border-radius: 0.2rem;
}

.bar1 {
  background: #3a3a3a;
}

.bar2 {
  background: #e57e12;
}

.bar3 {
  background: #ffe14b;
}

.bar4 {
  background: #96f189;
}

.bar5 {
  background: #74b8e6;
}

.bar6 {
  background: #8a74e6;
}

.hr-stats {
  font-size: 14px;
  color: #ccc;
}

.hr-stats span {
  display: block;
}

.metrics {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  font-size: 14px;
  text-align: center;
}

.metric i {
  font-size: 1.2rem;
  display: block;
  margin-bottom: 0.2rem;
}

.metric-value {
  font-size: 1.5rem;
  color: #fff;
}

.metric-label {
  color: #bbb;
  font-size: 1rem;
}

.fa-heart {
  animation: blinkHeart 1s infinite ease-in-out;
  color: #ff4f4f;
}

.user-offiline-card {
  color: white;
  text-align: center;
  position: relative;
}

.offline-status-dot {
  position: absolute;
  right: 0.1rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: #5c6964;
}

.user-offiline-card img {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  object-fit: cover;
  margin: 0.7rem auto;
}

.device-status {
  margin-top: 1.25rem;
  background: #1a1a1a;
  padding: 1rem;
  border-radius: 0.5rem;
  color: #94a39a;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 1rem;
}

.offline-text {
  font-size: 1.5rem;
  font-weight: bold;
  color: #bce1da;
}

@keyframes blinkHeart {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}
</style>